<template>
  <div>
    <div class="d-flex align-center justify-center">
      <div class="heading-4 font-weight-medium">Withdraw</div>
      <v-divider class="mx-6 border-vaults" vertical></v-divider>
      <div
        class="text-7 font-weight-medium px-2 py-1 rounded-5 black--text-abs bg-vaults"
      >
        DEFI VAULTS
      </div>
      <v-divider class="mx-6 border-vaults" vertical></v-divider>
      <img
        src="@/assets/icons/networks/ethereum.svg"
        alt="ethereum"
        height="20"
        width="20"
      />
    </div>
    <div class="d-flex justify-center mt-16">
      <div class="deposit-box pa-10">
        <div class="d-flex justify-center">
          <div
            :class="[
              'text-4 font-weight-medium',
              { 'gray--text clickable': step > 1 },
            ]"
            @click="step = 1"
          >
            Amount
          </div>
          <div
            :class="[
              'text-4 font-weight-medium ml-16',
              { 'gray--text': step <= 1 },
            ]"
          >
            Gas Option
          </div>
        </div>
        <v-divider class="border-vault my-10"></v-divider>
        <div class="mt-16">
          <amount-step
            v-if="step === 1"
            :vaultInfo="vaultInfo"
            :selectedAsset="selectedAsset"
            :balances="vaultBalancesState.result"
            :txPayload="txPayload"
            @next="setAmount"
            @selectAsset="setAsset"
          />
          <gas-option-step
            v-if="step === 2"
            :vaultInfo="vaultInfo"
            :selectedAsset="selectedAsset"
            :needApproveAccess="needApproveAccess"
            :txPayload="txPayload"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import AmountStep from "./AmountStep.vue";
import GasOptionStep from "./GasOptionStep.vue";

export default {
  components: {
    AmountStep,
    GasOptionStep,
  },
  data: () => ({
    step: 1,
    selectedAsset: null,
    txPayload: {
      amount: 0,
    },
  }),
  computed: {
    ...mapGetters({
      getVaultByIdentity: "projectConfig/getVaultByIdentity",
      projects: "projectConfig/projects",
      walletSelected: "userWallets/walletSelected",
      tokenAllowanceState: "vaults/tokenAllowance",
      vaultBalancesState: "vaults/vaultBalances",
    }),
    vaultInfo() {
      const identity = this.selectedAsset?.identity || this.$route.params.vault;
      const theVault = this.getVaultByIdentity(identity);
      return {
        type: theVault.vaultType,
        token: theVault.coin,
        ...theVault,
      };
    },
    loadingData() {
      return (
        this.vaultBalancesState.fetching || this.tokenAllowanceState.fetching
      );
    },
    needApproveAccess() {
      return (
        this.selectedAsset?.approveAccessWithdrawal &&
        !this.tokenAllowanceState.fetching &&
        new BN(this.tokenAllowanceState.result?.amount || 0).isEqualTo(0)
      );
    },
  },
  methods: {
    async getTokenAllowance() {
      if (!this.selectedAsset?.approveAccessWithdrawal) return;
      await this.$store.dispatch("vaults/fetchTokenAllowanceWithdrawalV3", {
        vault: this.selectedAsset?.type || this.vaultInfo.type,
        token: this.selectedAsset.coin,
      });
    },
    setProject() {
      this.$store.dispatch(
        "projectConfig/setCurrentProject",
        this.projects.find(p => p.name === "ethereum")
      );
    },
    setAsset(asset) {
      this.selectedAsset =
        asset || this.vaultInfo.tokens?.[0] || this.vaultInfo;
      if (this.walletSelected?.coin_network === "ethereum") {
        this.getTokenAllowance();
      }
    },
    setAmount(amount, ratio) {
      this.txPayload.amount = amount;
      this.txPayload.ratio = ratio;
      this.step = 2;
    },
  },
  mounted() {
    this.setProject();
    this.setAsset();
  },
  watch: {
    walletSelected: {
      immediate: true,
      handler({ address, coin_network }) {
        if (address && coin_network === "ethereum") {
          this.getTokenAllowance();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.deposit-box {
  width: 630px;
  height: 690px;
  border: 1px solid #49d999;
  border-radius: 16px;
}
</style>
